(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/line-ripple", [], factory);
	else if(typeof exports === 'object')
		exports["line-ripple"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["line-ripple"] = factory();
})(this, function() {
return 